// Generated by BUCKLESCRIPT, PLEASE EDIT WITH CARE

import * as $$Array from "bs-platform/lib/es6/array.js";
import * as React from "react";

require("./Dropdown.css");

function Dropdown(Props) {
  var values = Props.values;
  var match = Props.showFirst;
  var showFirst = match !== undefined ? match : false;
  var match$1 = Props.onChange;
  var onChange = match$1 !== undefined ? match$1 : (function (_e) {
        return /* () */0;
      });
  var match$2 = Props.name;
  var name = match$2 !== undefined ? match$2 : "";
  return React.createElement("select", {
              className: "xuder-dropdown",
              name: name,
              type: "text",
              onChange: onChange
            }, showFirst ? null : React.createElement("option", {
                    disabled: true,
                    selected: true,
                    value: "---"
                  }, "---"), $$Array.map((function (value) {
                    return React.createElement("option", {
                                key: value[0],
                                value: value[0]
                              }, value[1]);
                  }), values));
}

var make = Dropdown;

export {
  make ,
  
}
/*  Not a pure module */
